<template>
    <div class="home-view">词汇星球证书查询</div>
</template>

<script>

export default {
    name: 'HomeView',
    components: {
    },
    data() {
        return {}
    }
}
</script>

<style scoped lang="less">
.home-view {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f8f8f8;

    font-size: 24px;
}
</style>
